/* Inner Bazar — Premium Footer behaviour (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function setupAccordion(root) {
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;
    var items = root.querySelectorAll('[data-footer-collapsible]');
    items.forEach(function (el) {
      if (isMobile) {
        el.removeAttribute('open');
      } else {
        el.setAttribute('open', '');
      }
    });
  }

  function setupNewsletterForm(root) {
    var form = root.querySelector('.ib-newsletter__form');
    if (!form) return;

    form.addEventListener('submit', function () {
      var email = form.querySelector('.ib-newsletter__input');
      if (email && !email.checkValidity()) return;
      form.classList.add('is-loading');
    });
  }

  function setupBackToTop(root) {
    var button = root.querySelector('.ib-back-to-top');
    if (!button) return;

    var toggleVisibility = debounce(function () {
      if (window.scrollY > 480) {
        button.classList.add('is-visible');
      } else {
        button.classList.remove('is-visible');
      }
    }, 100);

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();

    button.addEventListener('click', function () {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: 0,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    });
  }

  function init(sectionId) {
    var root = document.getElementById('IBFooter-' + sectionId);
    if (!root) return;

    setupAccordion(root);
    setupNewsletterForm(root);
    setupBackToTop(root);

    window.addEventListener(
      'resize',
      debounce(function () {
        setupAccordion(root);
      }, 200)
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    var configs = window.IBFooterConfig || [];
    configs.forEach(function (cfg) {
      init(cfg.sectionId);
    });

    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target.querySelector('[id^="IBFooter-"]');
      if (el) {
        var id = el.id.replace('IBFooter-', '');
        init(id);
      }
    });
  });
})();